export const QUICK_TEMPLATES = [
  {
    label: "👋 Welcome",
    text: "Hi! Thanks for reaching out to The Sentinel Room. How can we assist you today?",
  },
  {
    label: "📅 Reservation",
    text: "Your reservation at The Sentinel Room is confirmed! We look forward to hosting you. Please let us know if your party size or timing needs adjusting.",
  },
  {
    label: "🍸 Hours & Location",
    text: "We are located at 215 W 19th St, Kansas City. Our speakeasy doors open at 5 PM. See you soon!",
  },
  {
    label: "🔍 Lost & Found",
    text: "Good news! We located your item at the lounge. You can pick it up with our host stand anytime during regular operating hours.",
  },
  {
    label: "🎟️ Event Tickets",
    text: "Thank you for joining our upcoming tasting event! Check-in details and your event itinerary have been confirmed.",
  },
];

/**
 * AI Draft Templates
 * The {greeting} variable will automatically be replaced with "Hi [Name]," or "Hi there,"
 */
export const AI_DRAFT_TEMPLATES = {
  // Triggers: "hour", "open", "tonight", "time"
  hours: "{greeting} thanks for reaching out! We're open Tuesday through Saturday starting at 5 PM. We usually stay open until late, and walk-ins are always welcome at the bar. Let me know if you need anything else!",
  
  // Triggers: "reserv", "table", "book", "party", "seat"
  reservations: "{greeting} we'd absolutely love to host you! You can easily grab a reservation on our website, or if you prefer, just reply with your ideal date, time, and how many people are in your party, and I'll personally check what we have available for you.",
  
  // Triggers: "menu", "drink", "cocktail", "whiskey", "bourbon"
  menu: "{greeting} we've got a pretty extensive whiskey collection and a rotating menu of seasonal craft cocktails. You can check out our current menu on the website, or just ask one of our bartenders when you come in—they love recommending new pours!",
  
  // Triggers: "dress", "wear", "attire"
  dressCode: "{greeting} our dress code is just upscale casual. Think cocktail lounge attire—we just want you to feel comfortable while enjoying the speakeasy vibe. Looking forward to having you in!",
  
  // Triggers: "event", "private", "buyout", "hire"
  events: "{greeting} thanks for thinking of us for your event! We'd love to chat about private hosting options. Do you have a specific date in mind, and roughly how many guests are you expecting?",
  
  // Default fallback when no keywords match
  default: "{greeting} thanks for reaching out to us! Let me know how we can help you out today."
};
